var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChoices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.364,
    height: 17.011,
    viewBox: "0 0 14.364 17.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#00959c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-47.031)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.736 2.557)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M100.309,77.812a.266.266,0,0,0-.266.266.586.586,0,1,1-.586-.586.266.266,0,0,0,0-.533,1.119,1.119,0,1,0,1.119,1.119A.266.266,0,0,0,100.309,77.812Z",
    transform: "translate(-98.338 -76.96)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.736 5.682)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M100.309,171.874a.266.266,0,0,0-.266.266.586.586,0,1,1-.586-.586.266.266,0,0,0,0-.533,1.119,1.119,0,1,0,1.119,1.119A.266.266,0,0,0,100.309,171.874Z",
    transform: "translate(-98.338 -171.022)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.768 7.103)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M186.1,213.779h-1.989a.266.266,0,0,0,0,.533H186.1a.266.266,0,1,0,0-.533Z",
    transform: "translate(-183.849 -213.779)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.768 5.966)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M186.1,179.574h-1.989a.266.266,0,1,0,0,.533H186.1a.266.266,0,1,0,0-.533Z",
    transform: "translate(-183.849 -179.574)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.759 10.228)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M185.536,307.841h-1.421a.266.266,0,1,0,0,.533h1.421a.266.266,0,1,0,0-.533Z",
    transform: "translate(-183.849 -307.841)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.768 9.091)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M186.1,273.637h-1.989a.266.266,0,1,0,0,.533H186.1a.266.266,0,1,0,0-.533Z",
    transform: "translate(-183.849 -273.637)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.823 3.977)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M188.661,119.716h-4.546a.266.266,0,0,0,0,.533h4.546a.266.266,0,0,0,0-.533Z",
    transform: "translate(-183.849 -119.716)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(51.795 2.841)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M187.525,85.511h-3.409a.266.266,0,0,0,0,.533h3.409a.266.266,0,0,0,0-.533Z",
    transform: "translate(-183.849 -85.511)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.736 8.807)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M100.309,265.937a.266.266,0,0,0-.266.266.586.586,0,1,1-.586-.586.266.266,0,1,0,0-.533,1.119,1.119,0,1,0,1.119,1.119A.266.266,0,0,0,100.309,265.937Z",
    transform: "translate(-98.338 -265.085)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.031)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M57.525,0H47.866a.836.836,0,0,0-.835.835V12.767a.835.835,0,0,0,.835.835H52.7a.266.266,0,1,0,0-.533h-4.83a.3.3,0,0,1-.3-.3V.835a.3.3,0,0,1,.3-.3h9.659a.3.3,0,0,1,.3.3V9.642a.266.266,0,0,0,.533,0V.835A.836.836,0,0,0,57.525,0Z",
    transform: "translate(-47.031 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.902 5.966)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M246.067,184.413a.983.983,0,0,0-.691.194.97.97,0,0,0-.73-.478.983.983,0,0,0-.691.194.97.97,0,0,0-.73-.478.984.984,0,0,0-.544.1v-3.392a.977.977,0,0,0-1.076-.972,1.008,1.008,0,0,0-.877,1.012V184l-.783.783a1.676,1.676,0,0,0-.449,1.579l.594,2.526a2.246,2.246,0,0,0,2.2,1.739h2.4a2.258,2.258,0,0,0,2.255-2.255v-2.942A1.008,1.008,0,0,0,246.067,184.413Zm.344,3.955a1.724,1.724,0,0,1-1.722,1.722h-2.4a1.716,1.716,0,0,1-1.677-1.328l-.594-2.526a1.147,1.147,0,0,1,.307-1.08l.406-.406v.92a.266.266,0,0,0,.533,0V180.6a.471.471,0,0,1,.4-.482.444.444,0,0,1,.491.442v4.688a.266.266,0,1,0,.533,0v-.426a.444.444,0,0,1,.491-.442.471.471,0,0,1,.4.482v.67a.266.266,0,1,0,.533,0V185.1a.444.444,0,0,1,.491-.442.471.471,0,0,1,.4.482v.67a.266.266,0,0,0,.533,0v-.426a.444.444,0,0,1,.491-.442.471.471,0,0,1,.4.482v2.943Z",
    transform: "translate(-239.452 -179.578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChoices);
export default __webpack_public_path__ + "static/media/ic_choices.da6752c70eca33a205d3dcce5654d4a0.svg";
export { ForwardRef as ReactComponent };